export enum LogDivision {
  all,
  theatre,
  show,
  cleaning,
  other,
  companycall
}
